// Copyright (C) 2021 TANNER AG

import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation from "../layouts/Navigation";
import EMobilityTopicIntro from "../emobility/EMobilityTopicIntro";
import ActionLink from "../emobility/ActionLink";
import EMobilityContent from "../emobility/EMobilityContent";
import { useHashLink } from "../emobility/usehashscroll";
import TransportSolutionsToc from "./TransportSolutionsToc";
import withTSChapter from "../hocs/withTSChapter";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
    },
});

const TransportSolutionsTopic = ({ classes, setPageInfo, eMobilityChapter, generalTranslations, location }) => {
    const executeHashScroll = useHashLink();
    const number = `${eMobilityChapter.tSTopic.order}.${eMobilityChapter.order}`;

    useEffect(() => {
        if (location.hash) {
            executeHashScroll(location.hash.substring(1));
        }
    }, [location.hash]);

    useEffect(() => {
        setPageInfo({ title: eMobilityChapter.title, parentTitle: eMobilityChapter.tSTopic.title });
    }, [eMobilityChapter.title, eMobilityChapter.tSTopic.title]);

    console.log(eMobilityChapter);

    return (
        <React.Fragment>
            <Navigation />
            <div className={classes.mainWrapperStyle}>
                <EMobilityTopicIntro
                    kicker={eMobilityChapter.tSTopic.title.toUpperCase()}
                    title={eMobilityChapter.title}
                    number={number}
                    description={eMobilityChapter.intro}
                    sideNode={<TransportSolutionsToc chapter={eMobilityChapter} />}
                >
                    {eMobilityChapter.eMobilityContents &&
                        eMobilityChapter.eMobilityContents
                            .filter((content) => content.title)
                            .map((content, index) => {
                                const contentNumber = `${number}.${content.order}`;
                                return (
                                    <ActionLink key={index} href={`#chapter-${contentNumber}`} number={contentNumber}>
                                        {content.title}
                                    </ActionLink>
                                );
                            })}
                </EMobilityTopicIntro>
                <div className={classes.sectionsWrapperStyle}>
                    <EMobilityContent eMobilityContents={eMobilityChapter.eMobilityContents} number={number} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            slug: params.slug,
        };
    }),
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withTSChapter(),
    withPageInfo,
    withRouter,
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(TransportSolutionsTopic);



// WEBPACK FOOTER //
// ./src/transportsolutions/TransportSolutionsChapter.js